// Autogenerated
// -------------
// gulpfile.js --> generateBuildInfo

export const Build = {
    version: "6.22.28 (721fcbc75f96c013b4f8f570a246e17a)",
    jsVersion: "3fd256cd8a6abf949442964503a6c90d8270f064",
    jsSize:  468455,
    wasmVersion: "d9f429891f4b5026d1dacb873f8f7a2a",
    wasmSize: 2140358,
};
